import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { logError } from 'services/logging/logging';
import { WebEDIAnnotation } from 'services/webediErrors/types';
import { useWebEDIStore } from 'stores/webedi/webedi';
import { GenericError } from 'support/helpers/errors/errors';
import { TransactionsRoutes } from 'support/types';
import { SingleSparkleIcon } from 'components/CustomIcons/SingleSparkleIcon';
import { Button } from 'components/Form/Button';

import { ActionsSection } from '../../components/ActionsSection';
import { EditDocumentButton } from '../../components/EditDocumentButton/EditDocumentButton';

export const ErrorActions = ({
  messageId,
  error,
  isErrorFixed,
  viewMode,
}: {
  messageId: string | undefined;
  error: WebEDIAnnotation;
  isErrorFixed: boolean;
  viewMode: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const fieldPathsWithAISuggestions = useWebEDIStore((state) => state.fieldPathsWithAISuggestions);
  const gruSuggestionEnrichment = useWebEDIStore((state) => state.gruSuggestionEnrichment);
  const hasAISuggestion = fieldPathsWithAISuggestions.has(error.id);

  const navigateToEditSuggestion = () => {
    if (!messageId) {
      logError(new GenericError('messageId is undefined'));
      return;
    }

    navigate(generatePath(TransactionsRoutes.editSuggestion, { id: messageId }), undefined);
  };

  return (
    <ActionsSection>
      {hasAISuggestion && !isErrorFixed && gruSuggestionEnrichment && fieldPathsWithAISuggestions ? (
        <Button
          type="button"
          variant="ai"
          LeftIcon={SingleSparkleIcon}
          size="small"
          fullWidth
          onMouseDown={(e) => e.preventDefault()}
          onClick={navigateToEditSuggestion}
          analyticsId="webedi:resolve_with_ai"
        >
          {t('webedi:fieldAnnotation.resolveWithAI', { count: fieldPathsWithAISuggestions.size })}
        </Button>
      ) : null}

      {!isErrorFixed ? <EditDocumentButton viewMode={viewMode} annotation={error} /> : null}
    </ActionsSection>
  );
};
